import { useEffect, useState } from "react";
import { FiUserPlus } from "react-icons/fi";
import Members from "./Members";
import Invitations from "./Invitations";
import AddMembersModal from "./modals/AddMembers";
import { useGetTeam } from "../../../helpers/queries/team/useGetTeam";
import { useGetUserData } from "../../../helpers/queries/user/useGetUserData";
import { usePaginationSync } from "../../../hooks/usePaginationSync";
import { Spinner } from "../../../components/Spinner";
import { PaginationComponent } from "../../../components/Pagination";

const Team = () => {
  const [lastPage, setLastPage] = useState(1);
  const { currentPage, updatePage } = usePaginationSync(lastPage);
  const { isLoading, isSuccess, isError, data } = useGetTeam(currentPage);
  const { data: user } = useGetUserData();
  const role = user?.user?.role;

  useEffect(() => {
    setLastPage(data?.data?.last_page);
  }, [data]);

  const members = data?.data?.data?.filter(
    (item) => item?.status === "verified"
  );
  const invitations = data?.data?.data?.filter(
    (item) => item?.status === "pending"
  );

  const [activeTab, setActiveTab] = useState("members");

  const tabs = [
    { key: "members", label: "Members" },
    { key: "invitations", label: "Invitations" },
  ];

  return (
    <>
      <div className="w-full">
        <div className=" w-full lg:block flex justify-between items-center py-6 lg:px-10 md:px-5 px-4 bg-white border-b mb-4">
          <div className="w-full flex lg:flex-row flex-col justify-between lg:items-center gap-4 mb-1">
            <div className="flex gap-3 items-center">
              <div>
                <div className="w-[50px] h-[50px] rounded-full border border-neutral300 flex justify-center items-center">
                  <FiUserPlus className="text-neutral700 text-[20px]" />
                </div>
              </div>
              <div>
                <p className="text-darkGrey font-semibold md:block hidden">
                  Team
                </p>
                <p className="text-neutral600 md:text-base text-sm">
                  Manage and view team members with access to assets.
                </p>
              </div>
            </div>
            {role && role !== "Editor" && (
              <AddMembersModal setActiveTab={setActiveTab} />
            )}
          </div>
        </div>

        <div className="w-[250px] rounded-lg bg-neutral200 h-[40px] flex py-1 relative overflow-hidden ml-4">
          <div
            className={`absolute top-1 left-1  h-[calc(100%-8px)] rounded-lg bg-white transition-all duration-500`}
            style={{
              width: `${97.5 / tabs.length}%`,
              transform: `translateX(${
                tabs.findIndex((tab) => tab.key === activeTab) * 100
              }%)`,
            }}
          ></div>

          {tabs.map((tab) => (
            <button
              key={tab.key}
              className={`flex-1 relative z-10 text-center font-medium transition-colors duration-300 cursor-pointer ${
                activeTab === tab.key ? "text-neutral900" : "text-neutral700"
              }`}
              onMouseEnter={() => {
                setActiveTab(tab.key);
              }}
              onClick={() => setActiveTab(tab.key)}
            >
              {tab.label}
            </button>
          ))}
        </div>

        {isLoading && !isSuccess && (
          <div className="h-[55vh] w-full flex items-center justify-center">
            <Spinner />
          </div>
        )}

        {isError && !isLoading && (
          <div className="h-[45vh] w-full flex justify-center flex-col items-center">
            <p className="font-semibold text-xl text-center">
              There was an error getting the data
            </p>
            <p className="text-center">{data?.message ?? ""}</p>
          </div>
        )}

        {!isLoading && isSuccess && data?.data?.data?.length > 0 && (
          <>
            {activeTab === "members" && (
              <Members
                data={members}
                isLoading={isLoading}
                isSuccess={isSuccess}
                isError={isError}
                role={role}
              />
            )}
            {activeTab === "invitations" && (
              <Invitations
                data={invitations}
                isLoading={isLoading}
                isSuccess={isSuccess}
                isError={isError}
                role={role}
              />
            )}

            <PaginationComponent
              lastPage={data?.data?.last_page}
              currentPage={currentPage}
              handlePageChange={updatePage}
            />
          </>
        )}
      </div>
    </>
  );
};

export default Team;
